<template>
  <div class="homeView">
    <MdHomeVue class="MD" />
    <PcHomeNew class="PC" />
    <!-- <PcHome class="PC"/> -->
  </div>
</template>

<script>
// 移动端
import MdHomeVue from './MdHomeNew.vue'
// pc端
import PcHomeNew from './PcHomeNew1.vue'
// import PcHome from './PcHome.vue'
// 获取首页轮播图 // 获取产品线
import { getHomeSWipe, getProductTypeIndex } from '@/api/home'
// 获取产品
import { getProduct } from '@/api/product'
// 引入根路径
import request from '@/utils/request'
// 合作伙伴
import { getCooperative } from '@/api/aboutUs'

export default {
  name: 'homeView',
  components: {
    MdHomeVue,
    PcHomeNew
  },
  data () {
    return {
      swipeList: [], // 轮播图
      baseUrl: '', // g根路径
      productList: [], // 产品
      aboutFellows: [] // 合作伙伴
    }
  },
  created () {
    this.getHomeSWipe()
    this.baseUrl = request.defaults.baseURL
    this.getProduct()
    this.getCooperative()
    this.getProductTypeIndex()
    localStorage.setItem('index', '/')
  },
  methods: {
    // 获取轮播图
    async getHomeSWipe () {
      const res = await getHomeSWipe()
      // console.log(res, '轮播图')
      if (res.Msg === '获取成功') {
        this.swipeList = res.Data.DataList
        this.swipeList.forEach(item => {
          item.ImgUrl = this.baseUrl + item.ImgUrl
        })
        this.$store.commit('getHomeSwipeList', this.swipeList)
      }
    },

    // 获取产品
    async getProduct () {
      const res = await getProduct({ TypeId: 0, PageIndex: 1 })
      // console.log(res, 'chan产品')
      if (res.Msg === '获取成功') {
        this.productList = res.Data
        this.productList.forEach(item => {
          item.TitlePic = this.baseUrl + item.TitlePic
        })
        this.$store.commit('getProductList', this.productList)
        localStorage.setItem('productList', JSON.stringify(this.productList))
      }
    },
    // 获取合作伙伴
    async getCooperative () {
      // 写死一个
      const res = await getCooperative({ PageSize: 8, PageIndex: 1 })
      // console.log(res, '合作伙伴')
      if (res.Msg === '获取成功') {
        this.aboutFellows = res.Data.DataList
        this.aboutFellows.forEach(item => {
          item.ImgUrl = request.defaults.baseURL + item.ImgUrl
        })
        this.$store.commit('getAboutFellows', this.aboutFellows)
      }
    },
    // 获取产品线
    async getProductTypeIndex () {
      const res = await getProductTypeIndex()
      // console.log(res, '产品线')
      if (res.Msg === '获取成功') {
        this.$store.commit('getProductTitle', res.Data)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
// 移动
/* 当屏幕宽度小于750px时 */
@media only screen and (max-width: 750px) {
  .homeView {
    overflow: hidden;
    .PC {
      display: none;
    }
  }
}
// PC端/
/* 当屏幕宽度大于等于756px时 */
@media only screen and (min-width: 756px) {
  .homeView {
    margin-top: 0 !important;
    overflow: hidden;
    .MD {
      display: none;
    }
  }
}
</style>
